import React from "react";

import { cn } from "@/lib/utils";

import { CommandLoading as CommandLoadingPrimitive } from "cmdk";

const CommandLoading = React.forwardRef<
  React.ElementRef<typeof CommandLoadingPrimitive>,
  React.ComponentPropsWithoutRef<typeof CommandLoadingPrimitive>
>(({ className, children, ...props }, ref) => (
  <div
    className={cn(
      "max-h-[200px] overflow-y-auto overflow-x-hidden border border-secondary rounded-md absolute bg-white w-full",
    )}
  >
    <CommandLoadingPrimitive
      ref={ref}
      className="py-2 text-center text-body-sm w-full rounded-md bg-white"
      {...props}
    >
      {children}
    </CommandLoadingPrimitive>{" "}
  </div>
));

CommandLoading.displayName = CommandLoadingPrimitive.displayName;
export { CommandLoading };
